import React from 'react';

function Sup({ content, className }) {
    return <sup className={className}>{content}</sup>;
}

export default Sup;
